const DEBUG = false;

/**
 * @fileOverview 订阅者模式工具类
 * @author ZD @zd.com
 * @version 0.0.1
 */
class Event {

    /**
     * @constructor
     */
    constructor() {
        this.subscribers = { 'any': [] };
    }

    /**
     * @description 订阅事件
     * @param { Function } fn 处理函数
     * @param { String } type 事件名称，默认全局事件
     */
    on = (fn, type = 'any') => {
        let subs = this.subscribers;
        if (DEBUG) {
            console.debug("event on:", type)
            console.debug(subs[type])
        }
        if (!subs[type]) return subs[type] = [fn];
        subs[type].push(fn);
    }

    /**
     * @description 取消订阅
     * @param { String } type 事件名称，默认全局事件
     */
    off = (type = 'any', fn) => {
        const fns = this.subscribers[type];
        if (DEBUG) {
            console.debug("event off:", type)
            console.debug(fns)
        }
        fns.removeBuyValue(fn)
    }

    /**
     * @description 发布事件
     * @param { * } content 事件参数
     * @param { String } type 事件名称，默认全局事件
     */
    emit = (content, type = 'any') => {
        const fns = this.subscribers[type] || [];
        if (DEBUG) {
            console.debug("event emit:", type)
            console.debug(fns)
        }
        if (fns.length > 0) fns.map(fn => fn(content));
        else console.warn("没有订阅过此事件：", type);
    }
}

export default Event;